
import { forwardRef } from 'react';

const PastriesMenu = forwardRef<HTMLElement>((props, ref) => {
  return (
    <section
      ref={ref}
      className="py-12 px-[4%] opacity-0 transition-all duration-1000 bg-gradient-to-br from-[#F5EDE4] to-[#EDE4D8]"
    >
      {/* Header */}
      <div className="mb-10 text-center">
        <p className="text-[#D4AF37] text-sm tracking-[0.25em] uppercase mb-3 font-semibold">
          Hamur İşleri
        </p>
        <h2 className="font-playfair text-4xl lg:text-5xl text-[#1A365D] leading-tight">
          Geleneksel Lezzetler
        </h2>
      </div>

      {/* Three column layout */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
        {/* Kruvasan Card */}
        <div className="pastry-featured bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl shadow-xl group">
          <div className="overflow-hidden aspect-[4/3]">
            <img
              src="/kruvasan-1.png"
              alt="Kruvasan"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="p-5">
            <h3 className="font-cormorant text-3xl text-[#1A365D] mb-2">
              Kruvasan
            </h3>
            <p className="text-[#64748B] text-sm leading-relaxed">
              Fransız pastacılık geleneğinin en zarif örneği. Katmerli hamur yapısı ve tereyağının mükemmel uyumu.
            </p>
          </div>
        </div>

        {/* Poğaça Card */}
        <div className="bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl shadow-xl group">
          <div className="overflow-hidden aspect-[4/3]">
            <img
              src="/pogaca.png"
              alt="Poğaça"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="p-5">
            <h3 className="font-cormorant text-3xl text-[#1A365D] mb-2">
              Poğaça
            </h3>
            <p className="text-[#64748B] text-sm leading-relaxed">
              Sade, peynirli ve zeytin ezmeli çeşitleriyle her sabah taze pişirilen poğaçalar.
            </p>
          </div>
        </div>

        {/* Gül Böreği Card */}
        <div className="bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-2xl shadow-xl group">
          <div className="overflow-hidden aspect-[4/3]">
            <img
              src="/gul-boregi.png"
              alt="Gül Böreği"
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
          </div>
          <div className="p-5">
            <h3 className="font-cormorant text-3xl text-[#1A365D] mb-2">
              Gül Böreği
            </h3>
            <p className="text-[#64748B] text-sm leading-relaxed">
              Kıymalı, patatesli ve ıspanaklı seçenekleriyle ince yufkadan hazırlanan börekler.
            </p>
          </div>
        </div>
      </div>

      {/* Special note */}
      <div className="mt-12 flex justify-center relative z-10">
        <div className="bg-white/80 backdrop-blur-sm px-8 py-4 rounded-full shadow-lg border border-[#D4AF37]/20">
          <p className="text-[#1A365D] text-sm font-medium text-center flex items-center gap-2">
            <i className="ri-information-line text-[#D4AF37]"></i>
            Kruvasan haftanın belirli günlerinde servis edilmektedir.
          </p>
        </div>
      </div>
    </section>
  );
});

PastriesMenu.displayName = 'PastriesMenu';

export default PastriesMenu;
